export interface RoleModel {
   id: string;
   description: string;
   isGlobalRole: boolean;
   isSystemRole: boolean;
   permissions: string[];
}
